import React, { useState } from "react";
import { Button, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row, Col } from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useTranslation } from "react-i18next";

import { InspResponse } from "../../Inspection/services/inspectionsApi";

const IncidentResponse = ({ modal, setModal, toggle, selectedInspection }) => {
  const queryClient = useQueryClient();
  const [isLoading, setIsLoading] = useState(false);
  const [editorData, setEditorData] = useState("");

  const validationSchema = Yup.object().shape({
    reponse: Yup.string().required("Merci de renseigner le corps de la réponse"),
  });

  const initialValues = {
    reponse: "",
  };
const  { t} = useTranslation();
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        await InspResponse(selectedInspection?.id, { reponse: editorData });
        toast.success("La réponse a été envoyée avec succès 🎉");
        await queryClient.invalidateQueries("inspections");
        toggle();
        formik.resetForm();
        setEditorData("");
      } catch (error) {
        toast.error(`😌 Erreur: ${error?.message || error}`);
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "700px" }}
    >
      <ModalHeader toggle={toggle}>
        {t("incident_detail.title")} {selectedInspection?.category}
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
      <ModalBody>
          {isLoading ? (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "300px" }}>
              {t("incident_detail.sendReponse")} <Spin size="large" />
            </div>
          ) : (
            <>
              <Row>
                <Col md={12}>
                <label className="reponse">{t("incident_detail.reponse")}</label>
                  <ReactQuill
                    value={""}
                    onChange={() => {}}
                    modules={{
                      toolbar: [
                        ["bold", "italic", "underline"],
                        ["blockquote"],
                        [{ list: "ordered" }, { list: "bullet" }],
                        ["link"],
                        [{ align: [] }],
                      ],
                    }}
                    theme="snow"
                  />
                </Col>
              </Row>
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button className="bordered-btn-light" color="light" onClick={() => setModal(false)}>
          {t("inspections.cancel")}
          </Button>
          <Button type="submit" className="bordered-btn" disabled={isLoading}>
          {isLoading ? t("incident_detail.send") : t("incident_detail.add")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default IncidentResponse;
